export default function htmlDecode(textHtml: string) {
	const e = document.createElement("textarea");
	e.innerHTML = textHtml;

	return e.value;
}
